export const mainCategories = [
    {
      label: "PPE",
      link: "PPE",
      image: "/images/categoriesIcons/PPE.png",
      disabled: false
    },
    {
      label: "SITE SAFETY",
      link: "SITE-SAFETY",
      image: "/images/categoriesIcons/SITE_SAFETY.png",
      disabled: false
  
    },
    {
      label: "MERCHANDISING",
      link: "MERCHANDISING",
      image: "/images/categoriesIcons/POWER.png",
      disabled: false
  
    },
    {
      label: "TRANSIT",
      link: "TRANSIT",
      image: "/images/categoriesIcons/HAND_TOOLS.png",
      disabled: false
    }
  ];
  